'use strict';

/**
 * All JS for any action of the ProfileApplications on the server side
 */
waApp.controllers.ProfileApplications = {
	add: function() {
		// Check if company is present
		if ($('#country-id').length) {
			let countryInput = $('#country-id');
			let stateInput = $('#state-id');

			waUtils.postalCodeVsZipCode('#country-id', '#postal-code');

			countryInput.select2({
				placeholder: countryInput.attr('placeholder'),
				allowClear: true
			});

			stateInput.select2({
				placeholder: stateInput.attr('placeholder'),
				allowClear: true
			});

			waUtils.stateSelect('#country-id', '#state-id');
		}
	}
};
